<template>
  <div id="app">
    <img class="logo" alt="logo" src="./assets/logo.png">
    <NftLock/>
  </div>
</template>

<script>
import NftLock from './components/NftLock.vue'

export default {
  name: 'App',
  components: {
    NftLock
  }
}
</script>

<style scoped>
#app {
  font-family: 'Noto Sans JP', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
  min-height: 100vh;
  padding: 2rem 0;
}

.logo {
  width: 300px;
  height: auto;
  margin-bottom: 0.5rem;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

@media screen and (max-width: 800px) {
  .logo {
    width: 200px;
  }
}
</style>
